<template>
  <div class="text-right">
    <span>{{ moneyFormat }}</span>
  </div>
</template>
<script>
export default {
  name: "DTMoney",
  props:{
    data:{
      type: Object
    }
  },
  data() {
    return {
      money: null,
    }
  },
  mounted() {
    this.money = this.$attrs.column.extraData.money;
  },
  computed: {
    moneyFormat(){
      return  new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN' }).format(this.data[this.money])  ;
    }
  }
}
</script>